import script from "./v_order_list.vue?vue&type=script&lang=ts&setup=true"
export * from "./v_order_list.vue?vue&type=script&lang=ts&setup=true"

import "./v_order_list.vue?vue&type=style&index=0&id=40216f3b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Documents\\projects\\termounity\\public\\templates\\project\\Controllers\\Order\\Main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40216f3b"]])

export default __exports__